import { Checkbox, FormControlLabel } from "@mui/material";
import { useState } from "react";
import { useTenantTranslation } from "hooks/formatters";
import {
  EventLabellingModelStatus,
  LabellerType,
} from "src/store/api/generatedApi";

export const HUMAN_ICON = "\u{1F464}";

export const MODEL_STATUS_ICON: Record<EventLabellingModelStatus, string> = {
  active: "\u{1F916}",
  passive: "\u{1F441}\uFE0F",
  unused: "\u23F8\uFE0F",
};

export const renderLabellerTypeIcon = (
  labellerType: LabellerType,
  modelStatus: EventLabellingModelStatus | null
): string => {
  if (labellerType === "human") return HUMAN_ICON;
  if (modelStatus === null) return MODEL_STATUS_ICON.unused;
  return MODEL_STATUS_ICON[modelStatus];
};

export type LabellerStatusFiltersState = Readonly<{
  includeHumans: boolean;
  includeActiveModels: boolean;
  includePassiveModels: boolean;
  includeUnusedModels: boolean;
  setIncludeHumans: (value: boolean) => void;
  setIncludeActiveModels: (value: boolean) => void;
  setIncludePassiveModels: (value: boolean) => void;
  setIncludeUnusedModels: (value: boolean) => void;
}>;

export const useLabellerStatusFilters = (): LabellerStatusFiltersState => {
  const [includeHumans, setIncludeHumans] = useState(true);
  const [includeActiveModels, setIncludeActiveModels] = useState(true);
  const [includePassiveModels, setIncludePassiveModels] = useState(true);
  const [includeUnusedModels, setIncludeUnusedModels] = useState(false);

  return {
    includeHumans,
    includeActiveModels,
    includePassiveModels,
    includeUnusedModels,
    setIncludeHumans,
    setIncludeActiveModels,
    setIncludePassiveModels,
    setIncludeUnusedModels,
  };
};

export const matchesLabellerStatusFilter = (
  filters: LabellerStatusFiltersState,
  labellerType: LabellerType,
  modelStatus: EventLabellingModelStatus | null
): boolean => {
  if (labellerType === "human") return filters.includeHumans;
  if (modelStatus === "active") return filters.includeActiveModels;
  if (modelStatus === "passive") return filters.includePassiveModels;
  return filters.includeUnusedModels;
};

export const LabellerStatusFilterChips = ({
  filters,
}: {
  filters: LabellerStatusFiltersState;
}) => {
  const { t } = useTenantTranslation();
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={filters.includeHumans}
            onChange={(e) => {
              filters.setIncludeHumans(e.target.checked);
            }}
            size="small"
          />
        }
        label={`${HUMAN_ICON} ${t("human")}`}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={filters.includeActiveModels}
            onChange={(e) => {
              filters.setIncludeActiveModels(e.target.checked);
            }}
            size="small"
          />
        }
        label={`${MODEL_STATUS_ICON.active} ${t("activeModel")}`}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={filters.includePassiveModels}
            onChange={(e) => {
              filters.setIncludePassiveModels(e.target.checked);
            }}
            size="small"
          />
        }
        label={`${MODEL_STATUS_ICON.passive} ${t("passiveModel")}`}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={filters.includeUnusedModels}
            onChange={(e) => {
              filters.setIncludeUnusedModels(e.target.checked);
            }}
            size="small"
          />
        }
        label={`${MODEL_STATUS_ICON.unused} ${t("unusedModel")}`}
      />
    </>
  );
};
